var map = {
	"./template-10/bundles/bundles": "app/styles/client/templates/template-10/bundles/bundles",
	"./template-3/bundles/bundles": "app/styles/client/templates/template-3/bundles/bundles",
	"./template-7/bundles/bundles": "app/styles/client/templates/template-7/bundles/bundles",
	"./template-9/bundles/bundles": "app/styles/client/templates/template-9/bundles/bundles"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3303;